// extracted by mini-css-extract-plugin
export default {"employee":"EmployeeAvatars--employee--7d8e59","showHover":"EmployeeAvatars--showHover--612aa8","closeIcon":"EmployeeAvatars--closeIcon--7f708c"};